export function getStatementTitle(statementName: string, memberName: string | undefined): string {
  return memberName ? `${memberName} - ${statementName}` : statementName;
}
